import { FerretAction, REPLACE_FERRETS } from ".";
import { Ferret } from "non-ui/data";

export function replaceFerrets(ferrets: Ferret[]) : FerretAction {
	return {
		type: REPLACE_FERRETS,
		payload: ferrets.sort((a, b) => a.ferretOrder - b.ferretOrder)
	};
} 
